import { h, FunctionComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { Image } from '../types';
import ZoomButtons from './ZoomButtons';

const ZoomView: FunctionComponent<ZoomViewProps> = ({
    productName,
    images,
    selectedColour,
    selectColour,
    onClose
}) => {
    // add the modal background
    useEffect(() => {
        const backdrop = document.createElement('div');
        backdrop.classList.add('modal-backdrop', 'fade', 'show');

        document.body.classList.add('modal-open');
        document.body.insertBefore(backdrop, null);

        return () => {
            document.body.classList.remove('modal-open');
            backdrop.remove();
        };
    });

    const activeImage = images.filter(i => i.colour === selectedColour);

    return (
        <div
            class="modal zoom-modal fade show"
            tabIndex={-1}
            aria-modal="true"
            role="dialog"
            aria-labelledby="ZoomView"
            style={{ display: 'block' }}
        >
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header align-items-center">
                        <h2 id="ZoomView" class="mb-0 ml-2">
                            {productName} - <span class="text-lowercase">{selectedColour}</span>
                        </h2>
                        <button type="button" class="close" aria-label="Close" onClick={onClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <picture>
                            {activeImage.map(i => {
                                if (['image/jpeg', 'image/png'].includes(i.mime_type)) {
                                    return <img class="col-12" src={i.url} alt="" />;
                                }

                                return <source srcset={i.url} type={i.mime_type} />;
                            })}
                        </picture>
                        {images.length > 1 ? (
                            <ZoomButtons
                                images={images}
                                selectedColour={selectedColour}
                                onSelect={selectColour}
                            />
                        ) : null}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary py-3" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

interface ZoomViewProps {
    productName: string;
    images: Image[];
    onClose: () => void;
    selectedColour: string;
    selectColour: (colour: string) => void;
}

export default ZoomView;
